import compactEmojis from 'emojibase-data/zh/compact.json' with { type: 'json' };

import rawData from './data/en.json' with { type: 'json' };
import type { CompactEmoji, EmojiGroup } from './type';

const EMOJI_LABEL_OVERRIDES: Record<string, string> = {
  '1F44C': 'OK 手势',
  '1F4C0': 'DVD 光盘',
  '1F9EC': 'DNA 双螺旋',
  '1F1E8-1F1F6': '萨克岛旗帜',
};

function getEmojiLabel(emoji: { hexcode: string; label: string }) {
  return EMOJI_LABEL_OVERRIDES[emoji.hexcode] ?? emoji.label;
}

const localizedEmojis = compactEmojis as CompactEmoji[];
const localizedEmojiMap = new Map(
  localizedEmojis.map(emoji => [emoji.hexcode, emoji])
);

export const emojiLabelMap = new Map(
  localizedEmojis.flatMap(emoji => [
    [emoji.unicode, getEmojiLabel(emoji)],
    ...(emoji.skins?.map(skin => [skin.unicode, getEmojiLabel(skin)]) ?? []),
  ]) as [string, string][]
);

export const emojiGroupList: EmojiGroup[] = (rawData as EmojiGroup[]).map(
  group => ({
    ...group,
    emojis: group.emojis.map(emoji => {
      const localizedEmoji = localizedEmojiMap.get(emoji.hexcode);
      if (!localizedEmoji) {
        throw new Error(`未找到表情符号的中文名称：${emoji.hexcode}`);
      }
      return {
        ...emoji,
        label: getEmojiLabel(localizedEmoji),
        tags: [...(emoji.tags ?? []), ...(localizedEmoji.tags ?? [])],
      };
    }),
  })
);
